const config = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    INTERNAL_API_URL: 'https://igkmvovc22.execute-api.ap-southeast-1.amazonaws.com/prod',
    COMPANY_API_URL: 'https://458zs88src.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.oceanagold.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://rtlm1yf763.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
};

export default config;